import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import platform from "platform";

const firebaseConfig = {
  apiKey: "AIzaSyA27d3HpFglyJHH83_K_sWzkTfYDB7_a9Q",
  authDomain: "skedy-d318b.firebaseapp.com",
  projectId: "skedy-d318b",
  storageBucket: "skedy-d318b.appspot.com",
  messagingSenderId: "344956436761",
  appId: "1:344956436761:web:cbc5778f7303b6feff4588",
  measurementId: "G-08FSX0C5KY",
};

let app;
let messaging;

// Check if the current environment supports Firebase
const isFirebaseSupported = () => {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "Notification" in window &&
    "PushManager" in window
  );
};

// Initialize Firebase if supported
if (isFirebaseSupported()) {
  try {
    app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
  } catch (error) {
    console.error("Failed to initialize Firebase:", error);
  }
}

export const requestNotificationPermission = async (jwtToken, userId) => {
  // First check if Firebase is supported in this environment
  if (!isFirebaseSupported()) {
    console.error(
      "This browser does not support APIs required to use Firebase SDK",
    );
    localStorage.setItem("notificationPermission", null);
    return { success: false, error: "browser_not_supported" };
  }

  try {
    // Request permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Notification permission not granted");
      localStorage.setItem("notificationPermission", null);
      return { success: false, error: "permission_denied" };
    }

    // Get the token
    const token = await getToken(messaging, {
      vapidKey:
        "BBLpovNLSJ5j0hQWHUpKyvE-vRBTd4BjsbfYSj8E_1aJ1oRx2CBkbTcelZ44novuUvzECKxwFc1PkDxIrqVfqdY",
    });

    const baseUrl = process.env.REACT_APP_BASE_URL;
    const osPlatform = platform.os.family || "Unknown";

    if (token) {
      localStorage.setItem(
        "notificationPermission",
        JSON.stringify({ userId, token }),
      );

      fetch(`${baseUrl}/BusinessAccount/${userId}/DeviceInfo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${jwtToken}` }),
        },
        body: JSON.stringify({
          id: userId,
          pushId: token,
          system: osPlatform,
        }),
      });
    } else {
      console.error("No registration token available. Request permission.");
    }
  } catch (error) {
    console.error("Error retrieving FCM token:", error);
    localStorage.setItem("notificationPermission", null);
  }
};
